module.exports = __webpack_public_path__ + "static/media/size3.1d157bf6.png";